import { AiFillWarning } from "react-icons/ai";
import { BsDash } from "react-icons/bs";
import { FaCheckCircle } from "react-icons/fa";
import "./listItem.scss";

const ListItem = ({ verified, warning, header, paragraph, noIcon }) => {
  return (
    <div className="listItem">
      <div className="listItem__container">
        {noIcon ? null : (
          <div
            className={`listItem__icon ${
              verified ? "verified" : warning ? "warning" : ""
            }`}
          >
            {verified ? (
              <FaCheckCircle />
            ) : warning ? (
              <AiFillWarning />
            ) : (
              <BsDash />
            )}
          </div>
        )}

        <div className="listItem__body">
          <p className="listItem__paragraph">
            {header && (
              <span className="listItem__paragraphHeader">{header}</span>
            )}
            {paragraph}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ListItem;
